<div class="mb-30">
    Appointment Today
</div>
<app-appointment-ui></app-appointment-ui>